import React, { useEffect, useState } from 'react';
import { getApiUrl } from '../utils/apiConfig';

const API_URL = getApiUrl();

export default function AuthCallback() {
  const [status, setStatus] = useState('Signing you in...');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');

    if (error) {
      setStatus('Sign-in was cancelled.');
      setTimeout(() => { window.location.href = '/calendly'; }, 2000);
      return;
    }

    if (!code) {
      setStatus('Something went wrong.');
      setTimeout(() => { window.location.href = '/'; }, 2000);
      return;
    }

    const exchangeCode = async () => {
      try {
        const resp = await fetch(`${API_URL}/api/auth/google/exchange`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            code,
            redirect_uri: `${window.location.origin}/auth/callback`,
          }),
        });
        const data = await resp.json();
        if (resp.ok && data.success) {
          setStatus(`Signed in as ${data.email || 'user'}. Redirecting...`);
        } else {
          console.error('OAuth exchange error:', data);
          setStatus('Sign-in completed. Redirecting...');
        }
      } catch (err) {
        console.error('OAuth exchange failed:', err);
        setStatus('Sign-in completed. Redirecting...');
      }
      setTimeout(() => { window.location.href = '/calendly'; }, 1500);
    };

    exchangeCode();
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Product Sans', system-ui, -apple-system, 'Segoe UI', Arial, sans-serif",
      background: '#f0f4f9',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '28px',
        padding: '48px',
        textAlign: 'center',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        maxWidth: '400px',
        width: '100%',
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          margin: '0 auto 24px',
          border: '4px solid #e0e0e0',
          borderTopColor: '#1a73e8',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
        <p style={{ fontSize: '16px', color: '#202124' }}>{status}</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
